<script>
  export let report
  export let unit
</script>

<style>
  table {
    width: 100%;
  }
  tr {
    vertical-align: text-top;
  }
  .r {
    text-align: right;
    white-space: nowrap;
  }
</style>

{#await report}
  <h5>loading</h5>
{:then data}
  {#if data}
    <table>
      <tr>
        <td>1.</td>
        <td>
          {data.sailor}
          {data.is_first_timer == '1' ? '🐣' : ''}
          •
          <em>{data.boat}</em>
          {data.is_foiler == '1' ? '✔️' : ''}
        </td>
        <td class="r">
          {data.hasOwnProperty('reported_data') ? data.reported_data : ''}
          {unit}
        </td>
        <td class="r">
          <svg
            style="tran;transform: rotate(0.25turn)"
            width="20"
            height="20"
            fill="none"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            viewBox="0 0 20 20"
            stroke="currentColor"><path d="M9 5l7 7-7 7" /></svg>
        </td>
      </tr>
    </table>
  {/if}
{/await}
